export default "__VITE_ASSET__lptmnvRH__"